import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const visionItems = [
  {
    num: '01',
    icon: 'ri-heart-pulse-line',
    title: '家族の大切な時間を支える',
    desc: '命に寄り添うサービスを通じて、\n家族の大切な時間を静かに支える',
    keyword: '命',
    accent: '#C97B7B',
    image: 'https://public.readdy.ai/ai/img_res/fee6eeb3b705a6f1bed1e9cb0c287131.jpg',
  },
  {
    num: '02',
    icon: 'ri-gift-line',
    title: 'その子が生きた証を形に',
    desc: 'どんなに短い命でも、\nその存在を美しく残したい',
    keyword: '証',
    accent: '#C97B7B',
    image: 'https://readdy.ai/api/search-image?query=tiny%20delicate%20white%20lace%20newborn%20baby%20dress%20neatly%20folded%20on%20soft%20white%20linen%20fabric%20warm%20natural%20window%20light%20gentle%20shadows%20minimal%20elegant%20still%20life%20photography%20precious%20tender%20Japan&width=1200&height=600&seq=hug-vis2-v2&orientation=landscape',
  },
  {
    num: '03',
    icon: 'ri-links-line',
    title: '人と人をやさしくつなぐ',
    desc: '小さなぬくもりが誰かの支えになる\nそんな社会を目指して',
    keyword: 'つながり',
    accent: '#A8835A',
    image: 'https://readdy.ai/api/search-image?query=soft%20warm%20ivory%20cream%20fabric%20textures%20gently%20arranged%20minimal%20elegant%20background%20delicate%20folds%20natural%20light%20peaceful%20serene%20tranquil%20Japanese%20aesthetic%20wabi%20sabi%20stillness&width=1200&height=600&seq=hug-vis3-v2&orientation=landscape',
  },
];

export default function VisionSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: statementRef, isVisible: statementVisible } = useScrollAnimation();
  const refs = [
    useScrollAnimation(0.08),
    useScrollAnimation(0.08),
    useScrollAnimation(0.08),
  ];

  return (
    <section id="vision" className="py-28 px-6 bg-[#F9F4EF]">
      <div className="max-w-5xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-12 fade-in ${headerVisible ? 'visible' : ''}`}
        >
          <p className="text-[#C97B7B] text-xs tracking-[0.5em] mb-4 uppercase">Vision</p>
          <h2
            className="text-[#3A2E28] text-3xl md:text-4xl font-light mb-4"
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            ビジョン
          </h2>
          <div className="w-10 h-px bg-[#C8B99A] mx-auto" />
        </div>

        <div
          ref={statementRef}
          className={`text-center mb-16 fade-in ${statementVisible ? 'visible' : ''}`}
        >
          <h3
            className="text-[#3A2E28] text-xl md:text-2xl font-light leading-relaxed"
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            人の想いが循環する社会をつくる。
          </h3>
        </div>

        <div className="flex flex-col gap-5">
          {visionItems.map((item, i) => {
            const { ref, isVisible } = refs[i];
            const isEven = i % 2 === 0;

            return (
              <div
                key={item.num}
                ref={ref}
                className={`relative rounded-xl overflow-hidden fade-in ${isVisible ? 'visible' : ''}`}
                style={{ height: '280px' }}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-center"
                />
                {/* グラデーション */}
                <div
                  className={`absolute inset-0 ${
                    isEven
                      ? 'bg-gradient-to-r from-[#1C1410]/80 via-[#1C1410]/50 to-transparent'
                      : 'bg-gradient-to-l from-[#1C1410]/80 via-[#1C1410]/50 to-transparent'
                  }`}
                />

                <div
                  className={`absolute inset-0 flex items-center ${isEven ? 'justify-start' : 'justify-end'}`}
                >
                  <div className={`px-12 py-8 max-w-sm ${isEven ? 'text-left' : 'text-right'}`}>
                    <span
                      className="block text-7xl font-light leading-none mb-3 select-none"
                      style={{ color: 'rgba(255,255,255,0.12)', fontFamily: 'Georgia, serif' }}
                    >
                      {item.num}
                    </span>
                    <h3
                      className="text-white text-lg md:text-xl font-medium mb-3"
                      style={{ fontFamily: 'Noto Serif JP, serif' }}
                    >
                      {item.title}
                    </h3>
                    <p className="text-white/70 text-xs leading-loose whitespace-pre-line mb-4">
                      {item.desc}
                    </p>
                    <span
                      className="inline-block text-[10px] tracking-[0.4em] px-4 py-1.5 rounded-full border"
                      style={{ borderColor: `${item.accent}60`, color: 'rgba(255,255,255,0.75)' }}
                    >
                      {item.keyword}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
